import { useState } from "react";
import { viewListGenerailViewFilterByOptionsEvent, viewListGenerailViewFilterEvent, viewListGenerailViewFilterByOptionsNotDispatchedEvent } from "../../_events/order_list_view/find.event";
import { message } from "antd";
import { buildPagedDataFetched, emptyPagedData } from "../../_utils/paged-data";

const baseFilter = {
    not_dispatch: false,
    search: '',
    client: '',
    order: '',
    product: '',
    color: '',
    detail_id: '',
    cod_process: ''
};

export const useViewListFilter = () => {

    const [ data, setData ] = useState(emptyPagedData);
    const [ filter, setFilter ] = useState(baseFilter);
    const [ page, setPage ] = useState(0);
    const [ panel, setPanel ] = useState('search');

    const changeSearch = (value) => {
        setFilter({
            ...baseFilter,
            search: value
        });
    }

    const loadData = (page = 0) => {
        let newFilter = {...filter};
        newFilter.page = page;
        viewListGenerailViewFilterEvent(newFilter)
        .then(json => {
            setData(buildPagedDataFetched(json.paged));
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const loadDataOptions = (page = 0) => {
        let newFilter = {...filter};
        newFilter.page = page;
        if(newFilter.not_dispatch){
            viewListGenerailViewFilterByOptionsNotDispatchedEvent(newFilter)
            .then(json => {
                setData(buildPagedDataFetched(json.paged));
            })
            .catch(err => {
                message.error(err.message);
            });
        } else {
            viewListGenerailViewFilterByOptionsEvent(newFilter)
            .then(json => {
                setData(buildPagedDataFetched(json.paged));
            })
            .catch(err => {
                message.error(err.message);
            });
        }        
    }

    return {
        data, filter, page, panel, setPanel, setPage, setFilter, loadData, changeSearch, loadDataOptions
    }
}